export function useTableCartManagement(store, router) {
  if (!store) {
    console.warn("useTableCartManagement: Store instance is required");
    return {
      addToCart: () => {},
      updateQuantity: () => {},
      removeItem: () => {},
      checkout: () => {},
      setCartOpen: () => {},
      setCartPinned: () => {}
    };
  }

  function addToCart({ item, quantity, notes, modifiers }) {
    store.dispatch("tableOrder/addToCart", {
      item,
      quantity,
      note: notes,
      modifiers
    });
  }

  function updateQuantity(cartId, delta) {
    store.dispatch("tableOrder/updateQuantity", { cartId, delta });
  }

  function removeItem(cartId) {
    store.dispatch("tableOrder/removeItemCart", cartId);
  }

  function updateCartItem(cartId, { item, quantity, notes, modifiers }) {
    store.dispatch("tableOrder/updateCartItem", {
      cartId,
      item,
      quantity,
      note: notes,
      modifiers
    });
  }

  function checkout(options = {}) {
    if (!router) {
      console.warn(
        "useTableCartManagement: Router instance is required for checkout"
      );
      return;
    }

    const query = { ...options };
    const { storeAlias, tableHash, ...queryParams } = query;

    if (queryParams.viewCheck) {
      queryParams.viewCheck = "true";
    }

    const currentRoute = router.currentRoute || router.history?.current;
    const finalStoreAlias = storeAlias || currentRoute?.params?.storeAlias;
    const finalTableHash = tableHash || currentRoute?.params?.tableHash;

    if (finalStoreAlias && finalTableHash) {
      router.push({
        name: "TableCheckout",
        params: {
          storeAlias: finalStoreAlias,
          tableHash: finalTableHash
        },
        query: queryParams
      });
    } else {
      console.warn(
        "useTableCartManagement: Missing storeAlias or tableHash for checkout"
      );
    }

    store.commit("SET_CART_OPEN", false);
  }

  function setCartOpen(isOpen) {
    store.commit("SET_CART_OPEN", isOpen);
    if (!isOpen) {
      store.commit("tableOrder/CLEAR_MODIFIED_FLAGS");
    }
  }

  function setCartPinned(isPinned, cartItems = []) {
    store.commit("SET_CART_PINNED", isPinned);
    if (isPinned && cartItems.length > 0) {
      store.commit("SET_CART_OPEN", false);
    }
  }

  return {
    addToCart,
    updateQuantity,
    removeItem,
    updateCartItem,
    checkout,
    setCartOpen,
    setCartPinned
  };
}
